import React from "react";
import { useTranslation } from "react-i18next";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrganizationProductPerCategoryApi } from "../../../../../../services/Api/types";
import { getProductCategoryTitle } from "../services/products";
import OrganizationProductCategoryChartItem from "./Products/OrganizationProductCategoryChartItem";

interface Props {
	product: OrganizationProductPerCategoryApi;
	currency: string;
}

const OrganizationProductsCardItem = ({ product, currency }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<div className="d-flex flex-column organization-products-card-item">
			<h6 className="text-primary">{getProductCategoryTitle(product, t)}</h6>
			<div className="d-flex align-items-center justify-content-between mb-1">
				<p className="mb-0 text-muted">LTV</p>
				<h6 className="mb-0 text-dark">{FormatMoney({ amount: product.lifetime_value, currency })}</h6>
			</div>
			<div className="d-flex flex-column gap-2">
				<OrganizationProductCategoryChartItem
					value={product.mrr}
					title="MRR"
					currency={currency}
					percentValue={product.mrr_percent}
					potentialValue={product.potential_mrr}
					asMoney
				/>
				<OrganizationProductCategoryChartItem
					value={product.points_count}
					title={t("modules.organization.field.points_shortcut.title")}
					currency={currency}
					percentValue={product.points_percent}
					potentialValue={product.potential_points_count}
				/>
				<OrganizationProductCategoryChartItem
					value={product.products_count}
					title={t(`enums.organization.card_type.PRODUCTS`).toUpperCase()}
					currency={currency}
					percentValue={product.products_percent}
					potentialValue={product.potential_products_count}
				/>
			</div>
		</div>
	);
};

export default OrganizationProductsCardItem;
